import React, { Component } from 'react';
import './css/Home.css';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div className='home-page'>
        <img src="images/32EPD.3_0.png" height={700} />
        <img src="images/32EPD.9_0.png" height={500} />
      </div>
    );
  }
}
